var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinancesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41675 10.25C7.41675 10.8917 7.91675 11.4167 8.52508 11.4167H9.77508C10.3084 11.4167 10.7417 10.9583 10.7417 10.4C10.7417 9.79167 10.4751 9.575 10.0834 9.43333L8.08341 8.73333C7.68341 8.59167 7.41675 8.375 7.41675 7.76667C7.41675 7.20833 7.85008 6.75 8.38341 6.75H9.63341C10.2501 6.75833 10.7501 7.275 10.7501 7.91667",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08325 11.4583V12.075",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08325 6.09167V6.74167",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07508 15.7334C12.7524 15.7334 15.7334 12.7523 15.7334 9.07502C15.7334 5.39772 12.7524 2.41669 9.07508 2.41669C5.39779 2.41669 2.41675 5.39772 2.41675 9.07502C2.41675 12.7523 5.39779 15.7334 9.07508 15.7334Z",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5667 17.3166C12.3167 18.375 13.5417 19.0666 14.9417 19.0666C17.2167 19.0666 19.0666 17.2166 19.0666 14.9416C19.0666 13.5583 18.3833 12.3333 17.3417 11.5833",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancesActive);
export default __webpack_public_path__ + "static/media/finances-active.f41644768679a35a3ab0d7c9179cd64a.svg";
export { ForwardRef as ReactComponent };